import { apiSlice } from "./apiSlice";

export const CostSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getCostKpis: builder.query({
            query: ({ projectId, ...params }) => ({
                url: `Cost/${projectId}/cost-kpis`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            // providesTags: ["allActionTrackerComment"],
        }),
        getCostSCurve: builder.query({
            query: ({ projectId, ...params }) => ({
                url: `Cost/${projectId}/cost-scurve`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            // providesTags: ["allActionTrackerComment"],
        }),
        getCostTracker: builder.query({
            query: ({
                projectId,
                parentId,
                activityId,
                startDateFrom,
                startDateTo,
                endDateFrom,
                endDateTo
            }) => {

                const params = {
                    projectId,
                    ...(activityId ? { activityId } : { parentTaskId: parentId }),
                    ...(startDateFrom && { startDateFrom }),
                    ...(startDateTo && { startDateTo }),
                    ...(endDateFrom && { endDateFrom }),
                    ...(endDateTo && { endDateTo }),
                };

                return {
                    url: `Cost/${projectId}/report`,
                    method: 'GET',
                    params: params,
                };
            },
            keepUnusedDataFor: 300,
        }),

        addCost: builder.mutation({
            query: (formData) => ({
                url: `Cost`,
                method: "POST",
                body: formData
            })
        }),
        getCostWeekly: builder.query({
            query: ({ projectId, activityId, monthStart }) => ({
                url: `Cost/${projectId}/weekly-report/activities/${activityId}`,
                method: 'GET',
                params: {
                    month: monthStart,       // "2026-01-01"
                },
            }),

            // Good cache key behavior (monthStart included automatically because args are part of key)
            providesTags: (result, error, arg) => [
                { type: "CostWeekly", id: `${arg.projectId}|${arg.activityId ?? "ALL"}|${arg.month}` },
            ],

            // optional: keep cached data for quick reopen
            keepUnusedDataFor: 300, // seconds (5 min)
        }),

        updateCommittedCost: builder.mutation({
            query: (payload) => ({
                url: "Cost/committed-cost",
                method: "POST",
                body: payload
            })
        })
    }),

});

export const {
    useGetCostKpisQuery,
    useLazyGetCostKpisQuery,
    useGetCostSCurveQuery,
    useLazyGetCostSCurveQuery,
    useGetCostTrackerQuery,
    useLazyGetCostTrackerQuery,
    useAddCostMutation,
    useGetCostWeeklyQuery,
    useUpdateCommittedCostMutation
} = CostSlice;